document.addEventListener('DOMContentLoaded', function () {
  // フェードインセクションの処理
  const fadeInSections = document.querySelectorAll('.fade-in-section');

  const appearOnScroll = new IntersectionObserver(function (entries, observer) {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    });
  }, {
    threshold: 0.2,
    rootMargin: "0px 0px -20% 0px" // ビューポートの下から100pxの位置でトリガー
  });

  fadeInSections.forEach(section => {
    appearOnScroll.observe(section);
  });

  // FAQアコーディオンの処理
  document.querySelectorAll('.faq-question').forEach(question => {
    question.addEventListener('click', function () {
      const answer = this.nextElementSibling;
      const iconPlus = this.querySelector('.plus');
      const iconMinus = this.querySelector('.minus');

      answer.classList.toggle('open');
      if (answer.classList.contains('open')) {
        answer.style.height = answer.scrollHeight + "px";
        iconPlus.style.display = 'none';
        iconMinus.style.display = 'block';
      } else {
        answer.style.height = "0";
        iconPlus.style.display = 'block';
        iconMinus.style.display = 'none';
      }
    });
  });
});